import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ApplicableSourceFileTabModel } from '../models/applicableSourceFileTab.model';
import { QuestionsModel } from '../models/question.model';
import { QuestionOptionsModel } from '../models/questionOptions.model';
import { InfraService } from './infra.service';

@Injectable({
  providedIn: 'root'
})
export class UserInputsService {
  private configUrl: string;
  private configCoreUrl: string;

  constructor(private infraService:InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint1 + 'userinputs';
      this.configCoreUrl = data.WebEndPoint2 + 'Userinput';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }


    // if (localStorage.getItem('selectedregion') == '1') {
    //   this.configUrl = environment.apiUrl + 'userinputs';
    //   this.configCoreUrl = environment.coreUrl + 'Userinput';

    // }  else {

    //   this.configUrl = environment.apiUrlRow + 'userinputs';
    //   this.configCoreUrl = environment.coreRowUrl + 'Userinput';

    // }
  }

  public getUserinputsQuestionOptions(): Observable<QuestionOptionsModel[]> {
    return this.http.get<QuestionOptionsModel[]>(`${this.configCoreUrl}/getUserinputsQuestionOptions`);
    // userinputquestions
    // .catch(this.handleError);
  }

  public getUserinputsQuestionChildQustionByIdAndParentAnswer(parentid: number, parentanswer: number, tabId: number) {
    return this.http.get<QuestionsModel[]>(`${this.configCoreUrl}/getUserinputsQuestionChildQustionByIdAndParentAnswer/${parentid}/${parentanswer}/${tabId}`);
  }

  public getUserinputsQuestionChildQustionByIdAndParentAnswerList(tabId: number) {
    return this.http.get<QuestionsModel[]>(`${this.configCoreUrl}/GetUserinputsQuestionChildQustionByIdAndParentAnswerList/${tabId}`);
  }

  public saveUserinputsQuestionAnswer(engagementQuestions: ApplicableSourceFileTabModel[]) {
    // return this.http.post<QuestionsModel[]>(`${this.configUrl}/`, engagementQuestions);
    return this.http.post < QuestionsModel[]>(`${this.configCoreUrl}/`, engagementQuestions);
  }

  public getApplicableSourceFileTabs(engagementId: number) {
    return this.http.get<ApplicableSourceFileTabModel[]>(`${this.configCoreUrl}/getApplicableSourceFileTabs/${engagementId}`);
  }

  public getUserInputsQuestions(tabId: number, selectedTemplate: number): Observable<QuestionsModel[]> {
    return this.http.get<QuestionsModel[]>(`${this.configCoreUrl}/getUserInputsQuestions/${tabId}/${selectedTemplate}`);
  }

  public getAmountQuestions(tabId: number): Observable<QuestionsModel[]> {
    return this.http.get<QuestionsModel[]>(`${this.configCoreUrl}/getAmountQuestions/${tabId}`);
  }

  public deleteProcessingData(engagementId: number) {
    return this.http.post(`${this.configCoreUrl}/deleteProcessingData/${engagementId}`, {});
  }
  public checkProcessingData(engagementId: number) {
    return this.http.post(`${this.configCoreUrl}/checkProcessingData/${engagementId}`, {});
  }
  
  public getQuestionTwoValue(engagementId: number) {
    return this.http.get(`${this.configCoreUrl}/getQuestionTwoValue/${engagementId}`);
  }
}
